<template>
  <VWidget
    :title="$t('Active dates')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
        >
          <v-menu
            ref="startDatePicker"
            v-model="startDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDate"
                :error-messages="item.displayErrors('start_date')"
                :label="$t('Starts at')"
                outline
                prepend-inner-icon="event"
                v-on="on"
              />
            </template>
            <date-time-picker
              :date-time="startDate"
              @confirmed="startDatePicked"
            />
          </v-menu>

          <v-menu
            v-model="endDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDate"
                :error-messages="item.displayErrors('end_date')"
                :label="$t('Ends at')"
                prepend-inner-icon="event"
                outline
                v-on="on"
              />
            </template>
            <date-time-picker
              :date-time="endDate"
              @confirmed="endDatePicked"
            />
          </v-menu>
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>
import DateTimePicker from '../../../../components/DateTimePicker'

export default {
  name: 'DiscountSingleDates',

  components: {
    DateTimePicker
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      startDatePicker: false,
      endDatePicker: false
    }
  },

  computed: {
    startDate: {
      get () {
        if (!this.item.start_date) {
          return null
        }
        return this.formatDate(this.item.start_date)
      },
      set (value) {
        this.item.start_date = value
      }
    },
    endDate: {
      get () {
        if (!this.item.end_date) {
          return null
        }
        return this.formatDate(this.item.end_date)
      },
      set (value) {
        this.item.end_date = value
      }
    }
  },

  methods: {
    startDatePicked (date) {
      this.startDatePicker = false
      this.startDate = date
    },

    endDatePicked (date) {
      this.endDatePicker = false
      this.endDate = date
    },
    formatDate (inputDate) {
      const date = new Date(inputDate.replace(/ /g, 'T'))
      return `${date.toISOString().slice(0, 10)} ${date.toISOString().slice(11, 19)}`
    }
  }
}
</script>
